import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Configure axios to send cookies with every request
axios.defaults.withCredentials = true;

function getHeaders() {
  return {};
}

export const api = {
  // Team Development
  teamDevOverview: () => axios.get(`${API}/team-dev/overview`),
  teamDevOnboarded: () => axios.post(`${API}/team-dev/onboarded`),
  teamDevHome: () => axios.get(`${API}/team-dev/home`),
  teamDevCheckinContext: () => axios.get(`${API}/team-dev/checkin-context`),
  teamDevSaveCheckin: (data) => axios.post(`${API}/team-dev/checkin`, data),
  teamDevGiveFeedback: (data) => axios.post(`${API}/team-dev/feedback`, data),
  teamDevInbox: () => axios.get(`${API}/team-dev/feedback/inbox`),
  teamDevSent: () => axios.get(`${API}/team-dev/feedback/sent`),
  teamDevMarkRead: (id) => axios.post(`${API}/team-dev/feedback/${id}/read`),
  teamDevThanks: (id) => axios.post(`${API}/team-dev/feedback/${id}/thanks`),
  teamDevThread: (id) => axios.get(`${API}/team-dev/feedback/${id}/thread`),
  teamDevThreadPost: (id, text) => axios.post(`${API}/team-dev/feedback/${id}/thread`, { text }),
  teamDevTakeaway: (id, data) => axios.post(`${API}/team-dev/feedback/${id}/takeaway`, data),
  teamDevCreateRequest: (data) => axios.post(`${API}/team-dev/requests`, data),
  teamDevRequests: () => axios.get(`${API}/team-dev/requests`),
  teamDevDismissRequest: (id) => axios.post(`${API}/team-dev/requests/${id}/dismiss`),
  teamDevGoals: () => axios.get(`${API}/team-dev/goals`),
  teamDevCreateGoal: (data) => axios.post(`${API}/team-dev/goals`, data),
  teamDevUpdateGoal: (id, data) => axios.put(`${API}/team-dev/goals/${id}`, data),
  teamDevGoalSignal: (id, note) => axios.post(`${API}/team-dev/goals/${id}/signal`, { note }),
  teamDevGoalIdea: (id, text) => axios.post(`${API}/team-dev/goals/${id}/idea`, { text }),
  teamDevIdeaReact: (id, reaction) => axios.post(`${API}/team-dev/goal-ideas/${id}/react`, { reaction }),
  teamDevConversation: (data) => axios.post(`${API}/team-dev/feedback/conversation`, data),
  teamDevMonthlyContext: (month) => axios.get(`${API}/team-dev/monthly/context`, { params: month ? { month } : {} }),
  teamDevMonthlyStart: () => axios.post(`${API}/team-dev/monthly/start`, {}),
  teamDevMonthlyUpdate: (id, data) => axios.put(`${API}/team-dev/monthly/${id}`, data),
  teamDevMonthlyTakeaway: (id, text) => axios.post(`${API}/team-dev/monthly/${id}/takeaway`, { text }),
  setTeamDevAccess: (userId, enabled) => axios.put(`${API}/team/${userId}/team-dev-access`, { enabled }),
  setIautoAccess: (userId, enabled) => axios.put(`${API}/team/${userId}/iauto-access`, { enabled }),
  setInfraAccess: (userId, level) => axios.put(`${API}/team/${userId}/infra-access`, { level }),
  // Claude Connector (remote MCP)
  mcpAuthorizeContext: (params) => axios.get(`${API}/mcp-auth/authorize/context`, { params }),
  mcpAuthorizeDecision: (body) => axios.post(`${API}/mcp-auth/authorize/decision`, body),
  mcpAdminOverview: () => axios.get(`${API}/mcp-auth/admin/overview`),
  mcpSetAccess: (userId, enabled) => axios.put(`${API}/mcp-auth/admin/users/${userId}/access`, { enabled }),
  mcpRevokeConnection: (familyId) => axios.delete(`${API}/mcp-auth/admin/connections/${familyId}`),
  mcpMe: () => axios.get(`${API}/mcp-auth/me`),
  mcpDisconnectMe: () => axios.delete(`${API}/mcp-auth/me/connections`),
  setUserMenu: (userId, hidden) => axios.put(`${API}/team/${userId}/menu`, { hidden }),
  getTopPages: () => axios.get(`${API}/auth/me/top-pages`),
  recordPageVisit: (itemId) => axios.post(`${API}/auth/me/page-visit`, { item_id: itemId }),

  // Projects
  listProjects: (status) =>
    axios.get(`${API}/projects`, { params: { status } }),
  getProjectStats: () =>
    axios.get(`${API}/projects/stats`),

  getProject: (id) =>
    axios.get(`${API}/projects/${id}`),

  createProject: (formData) =>
    axios.post(`${API}/projects`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    }),

  deleteProject: (id) =>
    axios.delete(`${API}/projects/${id}`),
  updateCompanyInfo: (id, data) =>
    axios.put(`${API}/projects/${id}/company-info`, data),
  batchUploadProjects: (file, targetStage, categoryId) => {
    const fd = new FormData();
    fd.append('file', file);
    const q = categoryId ? `category_id=${encodeURIComponent(categoryId)}` : `target_stage=${targetStage || 'ai_reviewed'}`;
    return axios.post(`${API}/projects/batch-upload?${q}`, fd, { headers: { 'Content-Type': 'multipart/form-data' }, timeout: 0 });
  },
  getBatchUploadStatus: (batchId) => axios.get(`${API}/projects/batch-upload/${batchId}`),
  listImportCategories: () => axios.get(`${API}/import-categories`),
  createImportCategory: (data) => axios.post(`${API}/import-categories`, data),
  updateImportCategory: (id, data) => axios.put(`${API}/import-categories/${id}`, data),
  deleteImportCategory: (id) => axios.delete(`${API}/import-categories/${id}`),
  getImportCategoryStats: () => axios.get(`${API}/import-categories/stats`),
  setProjectImportCategory: (id, categoryId) => axios.put(`${API}/projects/${id}/import-category`, { category_id: categoryId }),
  getBatchTemplate: () => `${API}/projects/batch-template`,
  approveDeal: (id) =>
    axios.post(`${API}/projects/${id}/approve`),
  castVote: (id, vote, voterName) =>
    axios.post(`${API}/projects/${id}/vote`, { vote, voter_name: voterName }),
  getVotes: (id) =>
    axios.get(`${API}/projects/${id}/votes`),
  claimDeal: (id, ownerId, randomProjectName) =>
    axios.put(`${API}/projects/${id}/claim`, { owner_id: ownerId, random_project_name: randomProjectName }),
  unclaimDeal: (id) =>
    axios.put(`${API}/projects/${id}/unclaim`),
  generateProjectName: (projectId) =>
    axios.get(`${API}/projects/generate-name`, { params: projectId ? { project_id: projectId } : {} }),
  getComments: (id) =>
    axios.get(`${API}/projects/${id}/comments`),
  addComment: (id, text) =>
    axios.post(`${API}/projects/${id}/comments`, { text }),
  deleteComment: (projectId, commentId) =>
    axios.delete(`${API}/projects/${projectId}/comments/${commentId}`),
  flagComment: (projectId, commentId, flagged) =>
    axios.put(`${API}/projects/${projectId}/comments/${commentId}/flag`, { flagged }),
  turnDownProject: (id, reason, benched, source, reasonTags, brokerSkip, fromStage) =>
    axios.put(`${API}/projects/${id}/turn-down`, { reason, benched: !!benched, source, reason_tags: reasonTags || [], broker_skip: !!brokerSkip, ...(fromStage ? { from_stage: fromStage } : {}) }),
  setAcFlag: (id, flagged) =>
    axios.put(`${API}/projects/${id}/ac-flag`, { flagged }),
  confirmPass: (id) =>
    axios.put(`${API}/projects/${id}/confirm-pass`),
  updatePassReason: (id, reason) =>
    axios.put(`${API}/projects/${id}/pass-reason`, { reason }),
  overridePass: (id, reason) =>
    axios.put(`${API}/projects/${id}/override-pass`, { reason: reason || '' }),
  ackReactivation: (id) =>
    axios.put(`${API}/projects/${id}/reactivation-ack`),
  reactivateProject: (id, stage, reason) =>
    axios.post(`${API}/projects/${id}/reactivate`, { stage, reason }),
  confirmNegativeResponse: (id) =>
    axios.post(`${API}/projects/${id}/negative-response/confirm`),
  dismissNegativeResponse: (id) =>
    axios.post(`${API}/projects/${id}/negative-response/dismiss`),
  getUnreadMentions: (id) =>
    axios.get(`${API}/projects/${id}/mentions/unread`),
  markMentionsRead: (id) =>
    axios.put(`${API}/projects/${id}/mentions/read`),
  getMentionsInbox: () =>
    axios.get(`${API}/mentions/inbox`),
  markAllMentionsRead: () =>
    axios.put(`${API}/mentions/read-all`),
  dismissAllMentions: () =>
    axios.put(`${API}/mentions/dismiss-all`),
  dismissDealMentions: (id) =>
    axios.put(`${API}/projects/${id}/mentions/dismiss`),
  confirmContact: (id) =>
    axios.put(`${API}/projects/${id}/confirm-contact`),
  overrideContact: (id) =>
    axios.put(`${API}/projects/${id}/override-contact`),
  confirmApproval: (id, body) =>
    axios.put(`${API}/projects/${id}/confirm-approval`, body || {}),
  overrideApproval: (id) =>
    axios.put(`${API}/projects/${id}/override-approval`),
  getPendingReviews: () =>
    axios.get(`${API}/projects/pending-reviews`),
  getWhosTurn: () =>
    axios.get(`${API}/whos-turn`),
  markViewed: (id) =>
    axios.post(`${API}/projects/${id}/view`),
  getViewedDeals: () =>
    axios.get(`${API}/viewed-deals`),
  runInactivityCheck: (overrides) =>
    axios.post(`${API}/admin/inactivity-check`, overrides || {}),
  exploreProjects: (filters) =>
    axios.post(`${API}/projects/explore`, filters),
  aiSearchStart: (payload) =>
    axios.post(`${API}/ai-search/start`, payload),
  aiSearchStatus: (runId) =>
    axios.get(`${API}/ai-search/${runId}`),
  uploadProjectDocument: (id, formData) =>
    axios.post(`${API}/projects/${id}/documents`, formData, { headers: { 'Content-Type': 'multipart/form-data' } }),

  // Chunked project creation
  initChunkedProject: (filename, totalChunks) =>
    axios.post(`${API}/upload/init`, { filename, total_chunks: totalChunks }),
  completeChunkedProject: (uploadId, name, dealType, companyWebsite, randomProjectName, autoScreen) =>
    axios.post(`${API}/projects/chunked`, { upload_id: uploadId, name, deal_type: dealType || 'brokered', company_website: companyWebsite || '', random_project_name: randomProjectName || '', auto_screen: !!autoScreen }),
  uploadChunk: (uploadId, chunkIndex, blob) => {
    const fd = new FormData();
    fd.append('file', blob, `chunk_${chunkIndex}`);
    return axios.post(`${API}/upload/${uploadId}/chunk/${chunkIndex}`, fd, { headers: { 'Content-Type': 'multipart/form-data' } });
  },
  completeChunkedUpload: (uploadId, projectId, label) =>
    axios.post(`${API}/upload/${uploadId}/complete`, { project_id: projectId, label }),
  addEvent: (id, data) =>
    axios.post(`${API}/projects/${id}/events`, data),
  updateEvent: (id, eventId, data) =>
    axios.put(`${API}/projects/${id}/events/${eventId}`, data),
  deleteEvent: (id, eventId) =>
    axios.delete(`${API}/projects/${id}/events/${eventId}`),
  generateCallPrep: (id, eventType, counterpartyRole) =>
    axios.post(`${API}/projects/${id}/generate-call-prep`, { event_type: eventType, counterparty_role: counterpartyRole }),
  analyzePhase1WithDoc: (id, docId) =>
    axios.post(`${API}/projects/${id}/analyze/phase1/${docId}`, {}),

  // Per-section screening
  screenSection: (id, section, docId) =>
    axios.post(`${API}/projects/${id}/screen/${section}`, { doc_id: docId }),
  scrapeSection: (id, section) =>
    axios.post(`${API}/projects/${id}/scrape/${section}`),
  getScreenStatus: (id) =>
    axios.get(`${API}/projects/${id}/screen-status`),

  // Create project (simple — no file required)
  createProjectSimple: (name, dealType, companyWebsite, randomProjectName, autoScreen) =>
    axios.post(`${API}/projects/create`, { name, deal_type: dealType, company_website: companyWebsite || '', random_project_name: randomProjectName || '', auto_screen: !!autoScreen }),

  // Analysis (legacy)
  analyzePhase1: (id) =>
    axios.post(`${API}/projects/${id}/analyze/phase1`, {}),

  analyzePhase2: (id) =>
    axios.post(`${API}/projects/${id}/analyze/phase2`, {}),
  getAnalysisStatus: (id) =>
    axios.get(`${API}/projects/${id}/analysis-status`),
  createPhase2Manual: (id) =>
    axios.post(`${API}/projects/${id}/phase2-manual`, {}),

  // Missing Info Review
  reviewMissing: (id, phase) =>
    axios.post(`${API}/projects/${id}/review-missing/${phase}`, {}),

  confirmCriteria: (id, phase, confirmations) =>
    axios.put(`${API}/projects/${id}/confirm-criteria/${phase}`, confirmations),

  // Override
  overrideScores: (id, phase, overrides) =>
    axios.put(`${API}/projects/${id}/scorecard/${phase}`, overrides),
  flagMissingInfo: (id, phase, criteriaId, flagged) =>
    axios.put(`${API}/projects/${id}/${phase}/flag-missing`, { criteria_id: criteriaId, flagged }),

  // Notes & Broker Requested
  updateNotes: (id, phase, criteriaId, data) =>
    axios.put(`${API}/projects/${id}/notes/${phase}/${criteriaId}`, data),

  // Pipeline Stage
  updateStage: (id, stage, reason, prioCriteria) =>
    axios.put(`${API}/projects/${id}/stage`, { stage, ...(reason ? { reason } : {}), ...(prioCriteria ? { prio_criteria: prioCriteria } : {}) }),
  setProjectPrio: (id, prioCriteria) =>
    axios.put(`${API}/projects/${id}/prio`, { prio_criteria: prioCriteria }),
  getPrioCriteria: () =>
    axios.get(`${API}/workflow/prio-criteria`),
  getPrioConfig: () => axios.get(`${API}/workflow/prio-config`),
  setPrioConfig: (cfg) => axios.put(`${API}/workflow/prio-config`, cfg),
  letterReturned: (id, note) => axios.post(`${API}/projects/${id}/letter-returned`, { note }),
  letterReturnedReactivate: (id) => axios.post(`${API}/projects/${id}/letter-returned/reactivate`),
  stageBack: (id, stage) =>
    axios.post(`${API}/projects/${id}/stage-back`, { stage }),
  proposeSkipOutreach: (id, reason, targetStage) =>
    axios.post(`${API}/projects/${id}/propose-skip-outreach`, { reason, target_stage: targetStage }),
  confirmSkipOutreach: (id) =>
    axios.put(`${API}/projects/${id}/confirm-skip-outreach`),
  overrideSkipOutreach: (id) =>
    axios.put(`${API}/projects/${id}/override-skip-outreach`),
  dismissResponseSuggestion: (id) =>
    axios.post(`${API}/projects/${id}/response-suggestion/dismiss`),
  dismissStageSuggestion: (id) =>
    axios.post(`${API}/projects/${id}/stage-suggestion/dismiss`),

  // Deal Photos
  uploadPhotos: (projectId, files) => {
    const fd = new FormData();
    files.forEach(f => fd.append('files', f));
    return axios.post(`${API}/projects/${projectId}/photos`, fd, { headers: { 'Content-Type': 'multipart/form-data' } });
  },
  deletePhoto: (projectId, photoId) =>
    axios.delete(`${API}/projects/${projectId}/photos/${photoId}`),

  // Funnel
  getFunnelStats: (view, asOf) =>
    axios.get(`${API}/funnel-stats`, { params: { ...(view ? { view } : {}), ...(asOf ? { as_of: asOf } : {}) } }),
  exportFunnelExcel: (view, asOf) =>
    axios.get(`${API}/funnel-stats/export.xlsx`, { params: { view, ...(asOf ? { as_of: asOf } : {}) }, responseType: 'blob' }),
  getStageStats: (stage) =>
    axios.get(`${API}/funnel-stage-stats/${stage}`),
  getFunnelOverrides: () =>
    axios.get(`${API}/funnel-overrides`),
  setFunnelOverrides: (data) =>
    axios.put(`${API}/funnel-overrides`, data),
  // Team analytics (admin)
  heartbeat: () =>
    axios.post(`${API}/analytics/heartbeat`),

  // Monday digest (Phase G)
  getMondayDigest: (force) =>
    axios.get(`${API}/digest/monday`, { params: force ? { force: 1 } : {} }),
  markMondayDigestSeen: () =>
    axios.post(`${API}/digest/monday/seen`),
  getMondayEmailSettings: () =>
    axios.get(`${API}/digest/monday-email/settings`),
  saveMondayEmailSettings: (body) =>
    axios.put(`${API}/digest/monday-email/settings`, body),
  sendMondayEmailNow: () =>
    axios.post(`${API}/digest/monday-email/send-now`),

  // Ask OLTA AI (deal-scoped Q&A)
  askDealAi: (projectId, question) =>
    axios.post(`${API}/projects/${projectId}/ask-ai`, { question }),
  getAskAiHistory: (projectId) =>
    axios.get(`${API}/projects/${projectId}/ask-ai/history`),
  clearAskAiHistory: (projectId) =>
    axios.delete(`${API}/projects/${projectId}/ask-ai/history`),
  askGlobalAi: (question) =>
    axios.post(`${API}/ask-ai/global`, { question }),
  getGlobalAskAiHistory: () =>
    axios.get(`${API}/ask-ai/global/history`),
  clearGlobalAskAiHistory: () =>
    axios.delete(`${API}/ask-ai/global/history`),
  getAiUsage: () =>
    axios.get(`${API}/ask-ai/usage`),
  getAiSettings: () =>
    axios.get(`${API}/ask-ai/settings`),
  saveAiSettings: (body) =>
    axios.put(`${API}/ask-ai/settings`, body),
  getAiCosts: () =>
    axios.get(`${API}/ask-ai/costs`),
  getAiAudit: (page = 1, perPage = 20) =>
    axios.get(`${API}/ask-ai/audit`, { params: { page, per_page: perPage } }),

  // KI-Kostenmanager (Admin)
  aiCostsOverview: (params) =>
    axios.get(`${API}/ai-costs/overview`, { params }),
  aiCostsLog: (params) =>
    axios.get(`${API}/ai-costs/log`, { params }),
  aiCostsSettings: () =>
    axios.get(`${API}/ai-costs/settings`),
  saveAiCostsSettings: (body) =>
    axios.put(`${API}/ai-costs/settings`, body),
  aiCostsExport: (params) =>
    axios.get(`${API}/ai-costs/export.xlsx`, { params, responseType: 'blob' }),

  // Contacts CRM
  getContact: (cid) =>
    axios.get(`${API}/contacts/${cid}`),
  getContactEngagements: (cid) =>
    axios.get(`${API}/contacts/${cid}/engagements`),
  getContacts: (search = '', type = '') =>
    axios.get(`${API}/contacts`, { params: { search, type } }),
  createContact: (body) =>
    axios.post(`${API}/contacts`, body),
  contactNameCheck: (first, last, email, phone) =>
    axios.get(`${API}/contacts/name-check`, { params: { first, last, email: email || '', phone: phone || '' } }),
  getProjectDuplicates: () =>
    axios.get(`${API}/projects/duplicates`),
  cleanupProjectDuplicates: (ids) =>
    axios.post(`${API}/projects/duplicates/cleanup`, { ids }),
  updateContact: (cid, body) =>
    axios.put(`${API}/contacts/${cid}`, body),
  deleteContact: (cid) =>
    axios.delete(`${API}/contacts/${cid}`),
  getContactTypes: () =>
    axios.get(`${API}/contacts/types`),
  addContactType: (label) =>
    axios.post(`${API}/contacts/types`, { label }),
  matchContact: (name, email = '', company = '') =>
    axios.get(`${API}/contacts/match`, { params: { name, email, company } }),
  uploadContactPhoto: (cid, file) => {
    const fd = new FormData();
    fd.append('file', file);
    return axios.post(`${API}/contacts/${cid}/photo`, fd);
  },
  contactPhotoFromUrl: (cid, url, fallbackUrl = '', source = 'url') =>
    axios.post(`${API}/contacts/${cid}/photo/from-url`, { url, fallback_url: fallbackUrl, source }),
  searchContactPhotos: (name, company = '') =>
    axios.get(`${API}/contacts/photo-search`, { params: { name, company } }),
  getProjectContacts: (projectId) =>
    axios.get(`${API}/contacts/by-project/${projectId}`),
  linkContactToProject: (cid, projectId) =>
    axios.post(`${API}/contacts/${cid}/link/${projectId}`),
  unlinkContactFromProject: (cid, projectId) =>
    axios.delete(`${API}/contacts/${cid}/link/${projectId}`),
  getContactsRanking: () =>
    axios.get(`${API}/contacts/ranking`),

  // Outreach sequences
  getSequenceTemplates: (projectId) =>
    axios.get(`${API}/outreach-sequences/templates`, { params: projectId ? { project_id: projectId } : {} }),
  createSequenceTemplate: (data) =>
    axios.post(`${API}/outreach-sequences/templates`, data),
  updateSequenceTemplate: (tid, data) =>
    axios.put(`${API}/outreach-sequences/templates/${tid}`, data),
  deleteSequenceTemplate: (tid) =>
    axios.delete(`${API}/outreach-sequences/templates/${tid}`),
  saveSequenceSettings: (data) =>
    axios.put(`${API}/outreach-sequences/settings`, data),
  getSequenceReadiness: (contactId, templateId = '') =>
    axios.get(`${API}/outreach-sequences/readiness`, { params: { contact_id: contactId, template_id: templateId } }),
  enrollInSequence: (data) =>
    axios.post(`${API}/outreach-sequences/enroll`, data),
  getProjectEnrollments: (projectId) =>
    axios.get(`${API}/projects/${projectId}/sequence-enrollments`),
  addBreakupStep: (eid) =>
    axios.post(`${API}/outreach-sequences/enrollments/${eid}/add-breakup`),
  restoreBreakupStep: (eid) =>
    axios.post(`${API}/outreach-sequences/enrollments/${eid}/restore-breakup`),
  getStalledOutreach: () =>
    axios.get(`${API}/outreach-sequences/stalled`),
  completeSequenceStep: (eid, idx, data) =>
    axios.post(`${API}/sequence-enrollments/${eid}/steps/${idx}/complete`, data || {}),
  skipSequenceStep: (eid, idx) =>
    axios.post(`${API}/sequence-enrollments/${eid}/steps/${idx}/skip`),
  rescheduleSequenceStep: (eid, idx, date) =>
    axios.post(`${API}/sequence-enrollments/${eid}/steps/${idx}/reschedule`, { date }),
  updateEnrollmentStepContent: (eid, idx, data) =>
    axios.put(`${API}/sequence-enrollments/${eid}/steps/${idx}/content`, data),
  approveSequenceStep: (eid, idx, data) =>
    axios.post(`${API}/sequence-enrollments/${eid}/steps/${idx}/approve`, data || {}),
  pauseEnrollment: (eid) =>
    axios.post(`${API}/sequence-enrollments/${eid}/pause`),
  resumeEnrollment: (eid) =>
    axios.post(`${API}/sequence-enrollments/${eid}/resume`),
  cancelEnrollment: (eid) =>
    axios.delete(`${API}/sequence-enrollments/${eid}`),
  getSequenceStats: () =>
    axios.get(`${API}/outreach-sequences/stats`),
  getSequencesToday: () =>
    axios.get(`${API}/outreach-sequences/today`),
  getBrokerTraffic: () =>
    axios.get(`${API}/broker-traffic`),
  syncBrokerTraffic: () =>
    axios.post(`${API}/broker-traffic/sync`),
  getBrokerThreadMessages: (tid) =>
    axios.get(`${API}/broker-traffic/threads/${tid}/messages`),
  getBrokerMailBody: (mid) =>
    axios.get(`${API}/broker-traffic/messages/${mid}/body`),
  draftBrokerThreadReply: (tid) =>
    axios.post(`${API}/broker-traffic/threads/${tid}/draft`),
  sendBrokerThreadReply: (tid, payload) =>
    axios.post(`${API}/broker-traffic/threads/${tid}/send`, payload),
  addBrokerThreadContact: (tid) =>
    axios.post(`${API}/broker-traffic/threads/${tid}/add-contact`),
  getLetterTemplate: () =>
    axios.get(`${API}/outreach/letter-template`),
  saveLetterTemplate: (body) =>
    axios.put(`${API}/outreach/letter-template`, body),

  // Broker campaigns
  listCampaigns: () =>
    axios.get(`${API}/broker-campaigns`),
  createCampaign: (data) =>
    axios.post(`${API}/broker-campaigns`, data),
  uploadCampaignAttachment: (cid, data) =>
    axios.post(`${API}/broker-campaigns/${cid}/attachment`, data),
  getCampaignBrokerPool: () =>
    axios.get(`${API}/broker-campaigns/pool`),
  getCampaign: (cid) =>
    axios.get(`${API}/broker-campaigns/${cid}`),
  startCampaign: (cid) =>
    axios.post(`${API}/broker-campaigns/${cid}/start`),
  pauseCampaign: (cid) =>
    axios.post(`${API}/broker-campaigns/${cid}/pause`),
  resumeCampaign: (cid) =>
    axios.post(`${API}/broker-campaigns/${cid}/resume`),
  cancelCampaign: (cid) =>
    axios.delete(`${API}/broker-campaigns/${cid}`),
  stopCampaignRecipient: (rid) =>
    axios.post(`${API}/campaign-recipients/${rid}/stop`),
  updateCampaignPace: (cid, data) =>
    axios.post(`${API}/broker-campaigns/${cid}/pace`, data),
  purgeCampaign: (cid) =>
    axios.delete(`${API}/broker-campaigns/${cid}/purge`),
  reoptimizeLandingVideo: (lid) =>
    axios.post(`${API}/landing/${lid}/video/reoptimize`),
  completeStandardVideo: (uploadId) =>
    axios.post(`${API}/landing/settings/standard-video/complete`, { upload_id: uploadId }),
  useStandardVideo: (lid, version) =>
    axios.post(`${API}/landing/${lid}/video/use-standard`, { version }),
  addCampaignTranche: (cid, data) =>
    axios.post(`${API}/broker-campaigns/${cid}/tranche`, data),
  getCampaignCoverage: () =>
    axios.get(`${API}/broker-campaigns/coverage`),
  getOutreachHealth: () =>
    axios.get(`${API}/outreach-sequences/health`),

  // Deal inbox (AI-detected broker proposals)
  getDealProposals: () =>
    axios.get(`${API}/deal-proposals`),
  getBrokerTemplates: () =>
    axios.get(`${API}/broker-templates`),
  updateBrokerTemplate: (tid, body) =>
    axios.put(`${API}/broker-templates/${tid}`, { body }),
  requestProposalNda: (pid, emailBody) =>
    axios.post(`${API}/deal-proposals/${pid}/nda-request`, { email_body: emailBody || '' }),
  getProposalEmailPreview: (pid, template, params) =>
    axios.get(`${API}/deal-proposals/${pid}/email-preview`, { params: { template, ...(params || {}) } }),
  getProposalNdaFile: (pid) =>
    axios.get(`${API}/deal-proposals/${pid}/nda-file`, { responseType: 'blob' }),
  countersignProposalNda: (pid, data) =>
    axios.post(`${API}/deal-proposals/${pid}/nda-countersign`, data),
  getTeamKpis: (weekOffset = 0) =>
    axios.get(`${API}/team-kpis`, { params: { week_offset: weekOffset } }),
  getBreakupKpiLetters: (weekOffset = 0, kpi = 'team_breakups_sent') =>
    axios.get(`${API}/team-kpis/breakup-letters`, { params: { week_offset: weekOffset, kpi } }),
  getKpiConfig: () =>
    axios.get(`${API}/team-kpis/config`),
  saveKpiConfig: (data) =>
    axios.patch(`${API}/team-kpis/config`, data),
  setBrokerReceivedAt: (pid, receivedAt) =>
    axios.patch(`${API}/projects/${pid}/broker-received-at`, { received_at: receivedAt }),
  signBrokerNda: (pid, data) =>
    axios.post(`${API}/projects/${pid}/broker-nda/sign`, data),
  getProjectNdaFile: (pid) =>
    axios.get(`${API}/projects/${pid}/broker-nda/file`, { responseType: 'blob' }),
  getNdaApprovals: () =>
    axios.get(`${API}/nda-approvals`),
  approveNdaApproval: (pid) =>
    axios.post(`${API}/nda-approvals/${pid}/approve`),
  rejectNdaApproval: (pid, reason) =>
    axios.post(`${API}/nda-approvals/${pid}/reject`, { reason }),
  cancelNdaApproval: (pid) =>
    axios.post(`${API}/nda-approvals/${pid}/cancel`),
  getMailBrowser: (q, mode) =>
    axios.get(`${API}/broker-inbox/mail-browser`, { params: { q: q || '', mode: mode || 'proposal' } }),
  addMailAsProposal: (messageId) =>
    axios.post(`${API}/broker-inbox/mail-browser/add`, { message_id: messageId }),
  getBrokerDiscussions: () =>
    axios.get(`${API}/broker-discussions`),
  draftBrokerDiscussion: (did, force, tone) =>
    axios.post(`${API}/broker-discussions/${did}/draft`, { force: !!force, ...(tone || {}) }),
  sendBrokerDiscussion: (did, data) =>
    axios.post(`${API}/broker-discussions/${did}/send`, data),
  dismissBrokerDiscussion: (did) =>
    axios.post(`${API}/broker-discussions/${did}/dismiss`),
  setBrokerHeat: (contactId, hot) =>
    axios.patch(`${API}/broker-discussions/heat/${contactId}`, { hot }),
  saveDiscussionSettings: (data) =>
    axios.patch(`${API}/broker-discussions/settings`, data),
  getDiscussionSettings: () =>
    axios.get(`${API}/broker-discussions/settings`),
  addMailAsDiscussion: (messageId) =>
    axios.post(`${API}/broker-discussions/add-mail`, { message_id: messageId }),
  scanBrokerInvite: (did, text, force = false) =>
    axios.post(`${API}/broker-discussions/${did}/invite-scan`, { text, force }),
  sendBrokerInvite: (did, data) =>
    axios.post(`${API}/broker-discussions/${did}/send-invite`, data),
  manualBrokerInvite: (did) =>
    axios.post(`${API}/broker-discussions/${did}/invite-scan`, { manual: true }),
  previewCheckin: () =>
    axios.post(`${API}/broker-discussions/checkin-preview`),
  resumeCampaignRecipient: (rid) =>
    axios.post(`${API}/campaign-recipients/${rid}/resume`),
  getUnansweredBrokerMails: (days) =>
    axios.get(`${API}/broker-discussions/unanswered-mails`, { params: { days } }),
  ignoreUnansweredMail: (internetMessageId) =>
    axios.post(`${API}/broker-discussions/unanswered-mails/ignore`, { internet_message_id: internetMessageId }),
  inboundCallSearch: (q) =>
    axios.get(`${API}/inbound-call/search`, { params: { q } }),
  inboundCallBriefing: (letterId) =>
    axios.get(`${API}/inbound-call/briefing/${letterId}`),
  inboundCallBullets: (letterId, force) =>
    axios.post(`${API}/inbound-call/bullets/${letterId}`, { force: !!force }),
  getCallGuide: (key) =>
    axios.get(`${API}/inbound-call/guide/${key}`),
  getNdaReview: (pid) =>
    axios.get(`${API}/deal-proposals/${pid}/nda-review`),
  runNdaReview: (pid, force) =>
    axios.post(`${API}/deal-proposals/${pid}/nda-review`, { force: !!force }),
  getBrokerNda: (pid) =>
    axios.get(`${API}/projects/${pid}/broker-nda`),
  uploadBrokerNda: (pid, formData) =>
    axios.post(`${API}/projects/${pid}/broker-nda/upload`, formData, { headers: { 'Content-Type': 'multipart/form-data' } }),
  rerunBrokerNda: (pid) =>
    axios.post(`${API}/projects/${pid}/broker-nda/rerun`),
  importBrokerNdaFromMail: (pid) =>
    axios.post(`${API}/projects/${pid}/broker-nda/import-from-mail`),
  activateBrokerNdaVersion: (pid, vid) =>
    axios.post(`${API}/projects/${pid}/broker-nda/versions/${vid}/activate`),
  sendBrokerNdaEmail: (pid, payload) =>
    axios.post(`${API}/projects/${pid}/broker-nda/send-email`, payload),
  getNdaRefs: () =>
    axios.get(`${API}/broker-inbox/nda-refs`),
  uploadNdaRef: (kind, formData) =>
    axios.post(`${API}/broker-inbox/nda-refs/${kind}`, formData, { headers: { 'Content-Type': 'multipart/form-data' } }),
  deleteNdaRef: (kind) =>
    axios.delete(`${API}/broker-inbox/nda-refs/${kind}`),
  getNdaRefFile: (kind) =>
    axios.get(`${API}/broker-inbox/nda-refs/${kind}/file`, { responseType: 'blob' }),
  declineProposal: (pid, reason, emailBody) =>
    axios.post(`${API}/deal-proposals/${pid}/decline`, { reason, email_body: emailBody || '' }),
  getProjectBrokerProposal: (pid) =>
    axios.get(`${API}/projects/${pid}/broker-proposal`),

  // Work-time clock
  getMyTimeclock: () => axios.get(`${API}/timeclock/me`),
  clockIn: () => axios.post(`${API}/timeclock/clock-in`),
  clockOut: () => axios.post(`${API}/timeclock/clock-out`),
  setUserWeeklyTarget: (uid, hours) =>
    axios.put(`${API}/timeclock/user/${uid}/target`, { weekly_target_hours: hours }),
  setUserHoursVisibility: (uid, viewerIds) =>
    axios.put(`${API}/timeclock/user/${uid}/visibility`, { viewer_ids: viewerIds }),
  getVisibleHours: (month) =>
    axios.get(`${API}/timeclock/visible`, { params: month ? { month } : {} }),
  markProposalDuplicate: (pid, duplicateOfProjectId) =>
    axios.post(`${API}/deal-proposals/${pid}/mark-duplicate`, { duplicate_of_project_id: duplicateOfProjectId || '' }),
  suggestDeclineReason: (pid) =>
    axios.post(`${API}/deal-proposals/${pid}/suggest-decline-reason`),
  getBrokerInboxStats: () =>
    axios.get(`${API}/broker-inbox/stats`),
  getBrokerStats: () =>
    axios.get(`${API}/broker-stats`),
  getDealScanStatus: () =>
    axios.get(`${API}/deal-proposals/scan-status`),
  getDealProposalCount: () =>
    axios.get(`${API}/deal-proposals/count`),
  createDealFromProposal: (pid) =>
    axios.post(`${API}/deal-proposals/${pid}/create-deal`),
  dismissDealProposal: (pid) =>
    axios.post(`${API}/deal-proposals/${pid}/dismiss`),

  // NDA e-signature
  getNdaTemplate: (variant) =>
    axios.get(`${API}/nda-template`, { params: variant ? { variant } : {} }),
  listNdas: (pid) =>
    axios.get(`${API}/projects/${pid}/ndas`),
  sendNda: (pid, data) =>
    axios.post(`${API}/projects/${pid}/ndas`, data),
  resendNda: (nid) =>
    axios.post(`${API}/ndas/${nid}/resend`),
  cancelNda: (nid) =>
    axios.post(`${API}/ndas/${nid}/cancel`),
  remindNda: (nid) =>
    axios.post(`${API}/ndas/${nid}/remind`),
  dismissNdaReminder: (nid) =>
    axios.post(`${API}/ndas/${nid}/remind/dismiss`),
  remindProposalNda: (pid) =>
    axios.post(`${API}/deal-proposals/${pid}/nda-remind`),
  dismissProposalNdaReminder: (pid) =>
    axios.post(`${API}/deal-proposals/${pid}/nda-remind/dismiss`),
  getNdaRemindersDue: (mine) =>
    axios.get(`${API}/nda-reminders/due`, { params: mine ? { mine: 1 } : {} }),
  getNdaRemarks: (pid) =>
    axios.get(`${API}/projects/${pid}/nda-remarks`),
  importNdaRemarks: (pid, body) =>
    axios.post(`${API}/projects/${pid}/nda-remarks/import`, body),
  decideNdaRemark: (pid, cid, rid, body) =>
    axios.post(`${API}/projects/${pid}/nda-remarks/${cid}/remarks/${rid}/decide`, body),
  draftNdaRemarks: (pid, cid) =>
    axios.post(`${API}/projects/${pid}/nda-remarks/${cid}/draft`),
  updateNdaRemarks: (pid, cid, body) =>
    axios.put(`${API}/projects/${pid}/nda-remarks/${cid}`, body),
  sendNdaRemarks: (pid, cid, body) =>
    axios.post(`${API}/projects/${pid}/nda-remarks/${cid}/send`, body),
  discardNdaRemarks: (pid, cid) =>
    axios.delete(`${API}/projects/${pid}/nda-remarks/${cid}`),
  companyLookup: (company) =>
    axios.get(`${API}/contacts/company-lookup`, { params: { company } }),
  getDealsLite: (params) =>
    axios.get(`${API}/deals-lite`, { params }),
  verifyContactPhoto: (cid) =>
    axios.post(`${API}/contacts/${cid}/photo/verify`),
  deleteContactPhoto: (cid) =>
    axios.delete(`${API}/contacts/${cid}/photo`),
  getContactsTemplate: () =>
    axios.get(`${API}/contacts/template`, { responseType: 'blob' }),
  exportContacts: () =>
    axios.get(`${API}/contacts/export`, { responseType: 'blob' }),
  importContacts: (file) => {
    const fd = new FormData();
    fd.append('file', file);
    return axios.post(`${API}/contacts/import`, fd);
  },

  // Deal timeline + SLA health (Phase H)
  getDealTimeline: (id) =>
    axios.get(`${API}/projects/${id}/timeline`),
  getSlaHealth: () =>
    axios.get(`${API}/sla-health`),

  // Outreach checklist (WIP → Contacted)
  getOutreachSteps: (id) =>
    axios.get(`${API}/projects/${id}/outreach-steps`),
  tickOutreachStep: (id, key) =>
    axios.post(`${API}/projects/${id}/outreach-steps/${key}`),
  untickOutreachStep: (id, key) =>
    axios.delete(`${API}/projects/${id}/outreach-steps/${key}`),

  // Workflow role assignments
  getWorkflowAssignments: () =>
    axios.get(`${API}/workflow/assignments`),
  setWorkflowAssignments: (body) =>
    axios.put(`${API}/workflow/assignments`, body),
  getDealflowAnalytics: () =>
    axios.get(`${API}/analytics/dealflow`),
  getPipelineTiming: () =>
    axios.get(`${API}/pipeline-timing`),
  getDealLinks: (projectId) =>
    axios.get(`${API}/projects/${projectId}/links`),
  addDealLink: (projectId, data) =>
    axios.post(`${API}/projects/${projectId}/links`, data),
  removeDealLink: (linkId) =>
    axios.delete(`${API}/deal-links/${linkId}`),
  searchLinkTargets: (q, exclude) =>
    axios.get(`${API}/deal-links/search`, { params: { q, exclude } }),
  mstodoStatus: () =>
    axios.get(`${API}/mstodo/status`),
  mstodoConnect: () =>
    axios.get(`${API}/mstodo/connect`),
  mstodoDisconnect: () =>
    axios.post(`${API}/mstodo/disconnect`),
  mstodoSync: () =>
    axios.post(`${API}/mstodo/sync`),
  getMailPermission: () =>
    axios.get(`${API}/mail/permission`),
  getRecentCorrespondents: (q = '') =>
    axios.get(`${API}/mail/recent-correspondents`, { params: { q } }),
  getDealContacts: (dealId) =>
    axios.get(`${API}/deals/${dealId}/contacts`),
  addDealContact: (dealId, data) =>
    axios.post(`${API}/deals/${dealId}/contacts`, data),
  updateDealContact: (contactId, data) =>
    axios.put(`${API}/deal-contacts/${contactId}`, data),
  deleteDealContact: (contactId) =>
    axios.delete(`${API}/deal-contacts/${contactId}`),
  syncDealEmails: (dealId, full) =>
    axios.post(`${API}/deals/${dealId}/email-sync${full ? '?full=true' : ''}`),
  getDealEmails: (dealId) =>
    axios.get(`${API}/deals/${dealId}/emails`),
  getEmailBody: (activityId) =>
    axios.get(`${API}/mail/activity/${activityId}/body`),
  getIntakeFreeze: () =>
    axios.get(`${API}/workflow/intake-freeze`),
  setIntakeFreeze: (enabled) =>
    axios.put(`${API}/workflow/intake-freeze`, { enabled }),
  // Workflow tasks (Phase B)
  getTasks: () =>
    axios.get(`${API}/tasks`),
  getTaskSummary: () =>
    axios.get(`${API}/tasks/summary`),
  getDealTasks: (id) =>
    axios.get(`${API}/projects/${id}/tasks`),
  completeTask: (id, body) =>
    axios.post(`${API}/tasks/${id}/complete`, body || {}),
  claimTask: (id) => axios.post(`${API}/tasks/${id}/claim`),
  bulkCompleteTasks: (ids) =>
    axios.post(`${API}/tasks/bulk-complete`, { ids }),
  pushTaskToTodo: (id) =>
    axios.post(`${API}/tasks/${id}/push-todo`),
  createDealTask: (projectId, body) =>
    axios.post(`${API}/projects/${projectId}/tasks`, body),
  setOutreachChannel: (id, channel) =>
    axios.put(`${API}/projects/${id}/outreach-channel`, { channel }),
  getTeamAnalytics: () =>
    axios.get(`${API}/analytics/team`),
  getGlobalActivity: () =>
    axios.get(`${API}/activity`),
  getDealActivity: (projectId) =>
    axios.get(`${API}/activity/${projectId}`),
  geocodeCity: (city) =>
    axios.get(`${API}/geocode`, { params: { city } }),
  markActivitySeen: () =>
    axios.post(`${API}/activity/mark-seen`, {}),
  getProjectActivity: (id) =>
    axios.get(`${API}/projects/${id}/activity`),

  // Compare
  compareProjects: (ids) =>
    axios.post(`${API}/projects/compare`, { ids }),
  compareSearch: (q) =>
    axios.get(`${API}/projects/compare-search`, { params: { q } }),
  submitBugReport: (payload) =>
    axios.post(`${API}/bug-reports`, payload),
  listBugReports: () =>
    axios.get(`${API}/bug-reports`),
  updateBugReport: (id, data) =>
    axios.patch(`${API}/bug-reports/${id}`, data),
  resolveBugsBulk: (ids) =>
    axios.post(`${API}/bug-reports/resolve-bulk`, { ids }),
  getBugBundle: () => axios.get(`${API}/bug-reports/bundle`),
  bugBundleCopied: (id) => axios.post(`${API}/bug-reports/bundle/${id}/copied`),
  runBugBundleNow: () => axios.post(`${API}/bug-reports/bundle/run-now`),
  deleteBugReport: (id) =>
    axios.delete(`${API}/bug-reports/${id}`),
  bugScreenshotUrl: (id) =>
    `${API}/bug-reports/${id}/screenshot`,

  // PDF
  getPdfBlob: (id) =>
    axios.get(`${API}/projects/${id}/pdf`, { responseType: 'blob' }),
  getDocumentBlob: (projectId, docId) =>
    axios.get(`${API}/projects/${projectId}/documents/${docId}/file`, { responseType: 'blob' }),

  // Broker Email
  draftBrokerEmail: (id, phase) =>
    axios.post(`${API}/projects/${id}/draft-email`, { phase: phase || 'phase1' }),

  // Config
  getScorecardConfig: () =>
    axios.get(`${API}/scorecard-config`),

  // Budget
  getBudgetPlan: () =>
    axios.get(`${API}/budget/plan`),
  updateBudgetPlan: (data) =>
    axios.put(`${API}/budget/plan`, data),
  getBudgetAnalytics: () =>
    axios.get(`${API}/budget/analytics`),
  getBudgetRubriques: () =>
    axios.get(`${API}/budget/rubriques`),
  getBudgetRubriqueDetail: (rubriqueId) =>
    axios.get(`${API}/budget/rubrique/${rubriqueId}`),
  addCostItem: (data) =>
    axios.post(`${API}/budget/cost-items`, data),
  approveCostItem: (itemId) =>
    axios.post(`${API}/budget/cost-items/${itemId}/approve`),
  rejectCostItem: (itemId, reason) =>
    axios.post(`${API}/budget/cost-items/${itemId}/reject`, { reason: reason || '' }),
  listCostItems: (rubriqueId) =>
    axios.get(`${API}/budget/cost-items`, { params: rubriqueId ? { rubrique_id: rubriqueId } : {} }),
  updateCostItem: (itemId, data) =>
    axios.put(`${API}/budget/cost-items/${itemId}`, data),
  deleteCostItem: (itemId) =>
    axios.delete(`${API}/budget/cost-items/${itemId}`),
  deleteCostItemDoc: (itemId, docId) =>
    axios.delete(`${API}/budget/cost-items/${itemId}/documents/${docId}`),

  // Reimbursements
  getReimbursements: () =>
    axios.get(`${API}/budget/reimbursements`),
  markReimbursed: (month, personEmail) =>
    axios.post(`${API}/budget/reimbursements/${month}/${encodeURIComponent(personEmail)}`),
  undoReimbursement: (month, personEmail) =>
    axios.delete(`${API}/budget/reimbursements/${month}/${encodeURIComponent(personEmail)}`),

  // Export
  getBackupStatus: () => axios.get(`${API}/admin/backup-status`),
  initCostItemDocUpload: (itemId, filename, totalChunks) =>
    axios.post(`${API}/budget/cost-items/${itemId}/documents/init`, { filename, total_chunks: totalChunks }),
  uploadCostItemDocChunk: (itemId, uploadId, chunkIndex, blob) => {
    const fd = new FormData();
    fd.append('file', blob, `chunk_${chunkIndex}`);
    return axios.post(`${API}/budget/cost-items/${itemId}/documents/${uploadId}/chunk/${chunkIndex}`, fd, { headers: { 'Content-Type': 'multipart/form-data' } });
  },
  completeCostItemDocUpload: (itemId, uploadId, label) =>
    axios.post(`${API}/budget/cost-items/${itemId}/documents/${uploadId}/complete`, { label }),
  getCostItemDocUrl: (itemId, docId) =>
    `${API}/budget/cost-items/${itemId}/documents/${docId}/file`,

  // Reports
  generateInvestorEmail: (lang) =>
    axios.post(`${API}/reports/generate-email`, { lang: lang || 'en' }),
  listReports: () =>
    axios.get(`${API}/reports`),
  getReport: (reportId) =>
    axios.get(`${API}/reports/${reportId}`),
  updateReport: (reportId, body) =>
    axios.put(`${API}/reports/${reportId}`, { body }),
  deleteReport: (reportId) =>
    axios.delete(`${API}/reports/${reportId}`),

  // Team Management
  listTeam: () =>
    axios.get(`${API}/team`),
  listTeamMembers: () =>
    axios.get(`${API}/team/members`),
  updateUserRole: (userId, role) =>
    axios.put(`${API}/team/${userId}/role`, { role }),
  removeUser: (userId) =>
    axios.delete(`${API}/team/${userId}`),
  approveUser: (userId) =>
    axios.put(`${API}/team/${userId}/approve`),
  rejectUser: (userId) =>
    axios.put(`${API}/team/${userId}/reject`),
  getSecurityOverview: () =>
    axios.get(`${API}/admin/security/overview`),
  unlockUser: (userId) =>
    axios.post(`${API}/admin/security/unlock/${userId}`),
  getMailHealth: () =>
    axios.get(`${API}/mail/health`),
  getInboxScanStatus: () =>
    axios.get(`${API}/mail/inbox-scan`),
  inboxRescan: (userId, days) =>
    axios.post(`${API}/mail/inbox-rescan`, { user_id: userId, days: days || 7 }),
  inboxRescanAssign: (payload) =>
    axios.post(`${API}/mail/inbox-rescan/assign`, payload),

  // Meetings
  getMeetingAgenda: (bucket) =>
    axios.get(`${API}/meetings/agenda`, { params: { bucket: bucket || 'current' } }),
  addToAgenda: (projectId, force, bucket) =>
    axios.post(`${API}/meetings/agenda`, { project_id: projectId, force: !!force, ...(bucket ? { bucket } : {}) }),
  addCustomAgendaItem: (title, notes, bucket) =>
    axios.post(`${API}/meetings/agenda/custom`, { title, notes: notes || '', ...(bucket ? { bucket } : {}) }),
  removeFromAgenda: (itemId) =>
    axios.delete(`${API}/meetings/agenda/${itemId}`),
  updateAgendaStatus: (itemId, status) =>
    axios.put(`${API}/meetings/agenda/${itemId}/status`, { status }),
  updateAgendaNotes: (itemId, notes, notesHtml) =>
    axios.put(`${API}/meetings/agenda/${itemId}/notes`, { notes, notes_html: notesHtml || '' }),
  setMeetingHint: (projectId, hint) =>
    axios.put(`${API}/projects/${projectId}/meeting-hint`, { hint }),
  setJointRecipients: (projectId, names) =>
    axios.put(`${API}/projects/${projectId}/joint-recipients`, { names }),
  updateAgendaDecision: (itemId, decision) =>
    axios.put(`${API}/meetings/agenda/${itemId}/decision`, { decision }),
  discussAgendaItem: (itemId, result, resultHtml) =>
    axios.post(`${API}/meetings/agenda/${itemId}/discuss`, { result, result_html: resultHtml || '' }),
  addAcDealsToAgenda: () =>
    axios.post(`${API}/meetings/agenda/add-ac-deals`),
  getMeetingSummaryNote: () =>
    axios.get(`${API}/meetings/summary-note`),
  saveMeetingSummaryNote: (summary, summaryHtml) =>
    axios.put(`${API}/meetings/summary-note`, { summary, summary_html: summaryHtml || '' }),
  reorderAgenda: (order) =>
    axios.put(`${API}/meetings/agenda/reorder`, { order }),
  finalizeMeeting: (lang, plaudOverride = false) =>
    axios.post(`${API}/meetings/finalize`, { lang: lang || 'de', plaud_override: plaudOverride }),
  getMeetingSettings: () =>
    axios.get(`${API}/meetings/settings`),
  saveMeetingSettings: (settings) =>
    axios.put(`${API}/meetings/settings`, settings),
  getMeetingEmailSettings: () =>
    axios.get(`${API}/meetings/email-settings`),
  saveMeetingEmailSettings: (settings) =>
    axios.put(`${API}/meetings/email-settings`, settings),
  sendPreMeetingEmailNow: () =>
    axios.post(`${API}/meetings/email-settings/send-now`),
  msConnections: () =>
    axios.get(`${API}/mstodo/connections`),
  getAcStatus: () =>
    axios.get(`${API}/meetings/ac-status`),
  setAcUpdateNote: (projectId, note) =>
    axios.put(`${API}/meetings/ac-update-note/${projectId}`, { note }),
  setAcDiscussed: (projectId, discussed) =>
    axios.put(`${API}/meetings/ac-discussed/${projectId}`, { discussed }),
  getAcSettings: () =>
    axios.get(`${API}/meetings/ac-settings`),
  saveAcSettings: (settings) =>
    axios.put(`${API}/meetings/ac-settings`, settings),
  sendAcEmailNow: () =>
    axios.post(`${API}/meetings/ac-settings/send-now`),
  getAcEmailPreview: () =>
    axios.get(`${API}/meetings/ac-settings/email-preview`),
  getAcFeedbackOverview: () =>
    axios.get(`${API}/meetings/ac-feedback-overview`),
  addAcQuestionDeals: () =>
    axios.post(`${API}/meetings/agenda/add-ac-question-deals`),
  getAcStats: () =>
    axios.get(`${API}/meetings/ac-stats`),
  getAcAgendaItems: () =>
    axios.get(`${API}/meetings/ac-agenda-items`),
  addAcAgendaItem: (title, notes) =>
    axios.post(`${API}/meetings/ac-agenda-items`, { title, notes: notes || '' }),
  deleteAcAgendaItem: (itemId) =>
    axios.delete(`${API}/meetings/ac-agenda-items/${itemId}`),
  reorderAcAgendaItems: (ids) =>
    axios.put(`${API}/meetings/ac-agenda-items/reorder`, { ids }),
  getAcPostMeeting: () =>
    axios.get(`${API}/meetings/ac-post-meeting`),
  parseAcPlaud: (text) =>
    axios.post(`${API}/meetings/ac-post-meeting/parse`, { text }),
  sendAcPostMeeting: (payload) =>
    axios.post(`${API}/meetings/ac-post-meeting/send`, payload),
  getAcBrokeredPrep: () =>
    axios.get(`${API}/meetings/ac-brokered-prep`),
  screenAcTeaser: (projectId, payload) =>
    axios.post(`${API}/meetings/ac-teaser-screen/${projectId}`, payload),
  saveAcManualFinancials: (projectId, history) =>
    axios.put(`${API}/meetings/ac-manual-financials/${projectId}`, { history }),
  saveAcManualBroker: (projectId, brokerName) =>
    axios.put(`${API}/meetings/ac-manual-broker/${projectId}`, { broker_name: brokerName }),
  setBrokeredStage: (projectId, stage) =>
    axios.put(`${API}/projects/${projectId}/brokered-stage`, { stage }),
  whatsnewStatus: () =>
    axios.get(`${API}/whatsnew/status`),
  sendAudit: () =>
    axios.get(`${API}/admin/send-audit`),
  decideWhatsnew: (version, decision) =>
    axios.post(`${API}/whatsnew/decide`, { version, decision }),
  logAdhocAcMeeting: (meetingDate) =>
    axios.post(`${API}/meetings/ac-post-meeting/adhoc`, meetingDate ? { meeting_date: meetingDate } : {}),
  getAllSequenceEnrollments: () =>
    axios.get(`${API}/outreach-sequences/enrollments`),
  shiftLettersToWednesday: () =>
    axios.post(`${API}/outreach-sequences/shift-letters-to-wednesday`),
  markEnrollmentAutoReply: (eid) =>
    axios.post(`${API}/sequence-enrollments/${eid}/mark-auto-reply`),

  // Vestaboard
  vestaboardPreview: () => axios.get(`${API}/vestaboard/manager/status`),
  // Vestaboard Board Manager (Admin)
  vbManagerStatus: () => axios.get(`${API}/vestaboard/manager/status`),
  vbManagerBoards: () => axios.get(`${API}/vestaboard/manager/boards`),
  vbManagerSaveSettings: (body) => axios.put(`${API}/vestaboard/manager/settings`, body),
  vbManagerSaveBoard: (id, body) => axios.put(`${API}/vestaboard/manager/boards/${id}/settings`, body),
  vbManagerReorder: (ids) => axios.put(`${API}/vestaboard/manager/rotation-order`, { ids }),
  vbManagerPush: (id, body) => axios.post(`${API}/vestaboard/manager/boards/${id}/push`, body || {}),
  vbManagerSimulate: (id) => axios.post(`${API}/vestaboard/manager/boards/${id}/simulate`),
  vbManagerCancelManual: () => axios.post(`${API}/vestaboard/manager/cancel-manual`),
  vbManagerDropEvent: (id) => axios.delete(`${API}/vestaboard/manager/events/${id}`),
  vbManagerLog: (limit = 100) => axios.get(`${API}/vestaboard/manager/log`, { params: { limit } }),
  vbManagerMessagePreview: (body) => axios.post(`${API}/vestaboard/manager/custom-message/preview`, body),
  vbManagerMessagePush: (body) => axios.post(`${API}/vestaboard/manager/custom-message/push`, body),
  vbManagerMessageSchedule: (body) => axios.post(`${API}/vestaboard/manager/custom-message/schedule`, body),
  vbManagerScheduled: () => axios.get(`${API}/vestaboard/manager/custom-message/scheduled`),
  vbManagerUnschedule: (id) => axios.delete(`${API}/vestaboard/manager/custom-message/scheduled/${id}`),
  spellcheckLetter: (letterId) =>
    axios.post(`${API}/outreach/letters/${letterId}/spellcheck`),
  applySpellcheck: (letterId, accept) =>
    axios.post(`${API}/outreach/letters/${letterId}/spellcheck/apply`, { accept }),
  apolloEnrichContact: (cid, payload) =>
    axios.post(`${API}/contacts/${cid}/apollo-enrich`, payload || {}),
  apolloApplyEmail: (cid) =>
    axios.post(`${API}/contacts/${cid}/apollo-apply`),
  apolloFindPhone: (cid, payload) =>
    axios.post(`${API}/contacts/${cid}/apollo-phone`, payload || {}),
  apolloPhoneStatus: (cid) =>
    axios.get(`${API}/contacts/${cid}/apollo-phone-status`),
  apolloApplyPhone: (cid, number) =>
    axios.post(`${API}/contacts/${cid}/apollo-phone-apply`, { number }),
  apolloApplyLinkedin: (cid) =>
    axios.post(`${API}/contacts/${cid}/apollo-apply-linkedin`),
  getApolloCredits: () =>
    axios.get(`${API}/apollo/credits`),
  getProjectAcFeedback: (projectId) =>
    axios.get(`${API}/projects/${projectId}/ac-feedback`),
  getMeetingHistory: () =>
    axios.get(`${API}/meetings/history`),
  getMeetingReport: (reportId) =>
    axios.get(`${API}/meetings/history/${reportId}`),
  deleteMeetingReport: (reportId) =>
    axios.delete(`${API}/meetings/history/${reportId}`),
  clearDiscussed: () =>
    axios.post(`${API}/meetings/clear-discussed`),
  translateToGerman: (text) =>
    axios.post(`${API}/meetings/translate`, { text }),
  parsePlaudSummary: (text) =>
    axios.post(`${API}/meetings/parse-plaud`, { text }),
  plaudDiagnose: () =>
    axios.get(`${API}/meetings/plaud-diagnose`),
  getPlaudSettings: () =>
    axios.get(`${API}/meetings/plaud-settings`),
  savePlaudSettings: (settings) =>
    axios.put(`${API}/meetings/plaud-settings`, settings),
  plaudConnect: () =>
    axios.get(`${API}/plaud/connect`),
  plaudDisconnect: () =>
    axios.post(`${API}/meetings/plaud-disconnect`),
  getPlaudRecordings: (days = 14) =>
    axios.get(`${API}/meetings/plaud-recordings?days=${days}`),
  getPlaudRecordingNote: (recordingId) =>
    axios.get(`${API}/meetings/plaud-recordings/${recordingId}/note`),
  getOwnerEngagement: () =>
    axios.get(`${API}/owner-engagement`),
  getColdEngagement: () =>
    axios.get(`${API}/engagement/cold`),
  getEngagementSettings: () =>
    axios.get(`${API}/engagement/settings`),
  saveEngagementSettings: (settings) =>
    axios.put(`${API}/engagement/settings`, settings),
  importPlaudRecording: (recordingId, name, createdAt) =>
    axios.post(`${API}/meetings/plaud-recordings/import`, { recording_id: recordingId, name, created_at: createdAt }),
  getPlaudInbox: () =>
    axios.get(`${API}/meetings/plaud-inbox`),
  checkPlaudInbox: () =>
    axios.post(`${API}/meetings/plaud-inbox/check`),
  dismissPlaudInbox: (id) =>
    axios.post(`${API}/meetings/plaud-inbox/${id}/dismiss`),
  markPlaudApplied: (id) =>
    axios.post(`${API}/meetings/plaud-inbox/${id}/applied`),

  // Meetings & Calls
  getDealMeetings: (projectId) =>
    axios.get(`${API}/projects/${projectId}/meetings`),
  restoreBackup: (file) => {
    const fd = new FormData(); fd.append('file', file);
    return axios.post(`${API}/admin/restore`, fd, { headers: { 'Content-Type': 'multipart/form-data' } });
  },
  deleteAllDeals: (confirmation, totpCode) =>
    axios.post(`${API}/admin/delete-all-deals`, { confirmation, totp_code: totpCode }),
  deleteStagDeals: (stage, totpCode) =>
    axios.post(`${API}/admin/delete-stage-deals`, { stage, totp_code: totpCode }),
  bypassApproval: (projectId, action) =>
    axios.put(`${API}/admin/bypass-approval/${projectId}`, { action }),

  getUserPreferences: () =>
    axios.get(`${API}/user-preferences`),
  setUserPreferences: (prefs) =>
    axios.put(`${API}/user-preferences`, prefs),
  getNotificationSettings: () =>
    axios.get(`${API}/notification-settings`),
  updateNotificationSettings: (triggers) =>
    axios.put(`${API}/notification-settings`, { triggers }),
  getFavorites: () =>
    axios.get(`${API}/favorites`),
  getTeamFavorites: () =>
    axios.get(`${API}/favorites/team`),
  toggleFavorite: (projectId) =>
    axios.put(`${API}/favorites/${projectId}`),
  getBookmarks: () =>
    axios.get(`${API}/bookmarks`),
  getBookmarkDeals: () =>
    axios.get(`${API}/bookmarks/deals`),
  getFavoriteDeals: () =>
    axios.get(`${API}/favorites/deals`),
  toggleBookmark: (projectId) =>
    axios.put(`${API}/bookmarks/${projectId}`),
  getSectorConfig: () =>
    axios.get(`${API}/sector-config`),
  updateSectorConfig: (sectors) =>
    axios.put(`${API}/sector-config`, { sectors }),

  pushSubscribe: (subscription) =>
    axios.post(`${API}/push-subscribe`, { subscription }),
  pushUnsubscribe: (endpoint) =>
    axios.post(`${API}/push-unsubscribe`, { endpoint }),
  sendTestPush: () =>
    axios.post(`${API}/push-test`),
  getPushStatus: (endpoint) =>
    axios.get(`${API}/push-status`, { params: { endpoint } }),
  getPushDiagnostic: () =>
    axios.get(`${API}/push-diagnostic`),
  pushResetAll: () =>
    axios.post(`${API}/push-reset-all`),
  pushTestDetailed: () =>
    axios.post(`${API}/push-test-detailed`),
  getNotificationHistory: (page = 1, perPage = 50) =>
    axios.get(`${API}/notifications/history`, { params: { page, per_page: perPage } }),

  // Outreach
  generateLetter: (projectId) =>
    axios.post(`${API}/outreach/generate-letter/${projectId}`),
  listLetters: () =>
    axios.get(`${API}/outreach/letters`),
  getOutreachSummary: () =>
    axios.get(`${API}/outreach/summary`),
  getLetter: (letterId) =>
    axios.get(`${API}/outreach/letters/${letterId}`),
  updateLetter: (letterId, data) =>
    axios.put(`${API}/outreach/letters/${letterId}`, data),
  updateInvestorAppetite: (projectId, data) =>
    axios.put(`${API}/projects/${projectId}/investor-appetite`, data),
  getUserActivityDetail: (userId, params) =>
    axios.get(`${API}/analytics/user/${userId}/detail`, { params }),
  resetUserPresence: (userId) =>
    axios.delete(`${API}/analytics/presence/${userId}`),
  trackPageview: (data) =>
    axios.post(`${API}/analytics/pageview`, data),
  updateApprovalNote: (projectId, data) =>
    axios.put(`${API}/projects/${projectId}/approval-note`, data),
  bulkLetterHeadline: (letterIds, include) =>
    axios.post(`${API}/outreach/letters/bulk-headline`, { letter_ids: letterIds, include_headline: include }),
  analyzeCallNote: (callId) =>
    axios.post(`${API}/calls/${callId}/analyze-note`),
  recordManualResponse: (letterId, data) =>
    axios.post(`${API}/outreach/letters/${letterId}/manual-response`, data),
  startEmailPassScan: () =>
    axios.post(`${API}/deal-proposals/scan-email-passes`),
  getEmailPassScan: () =>
    axios.get(`${API}/deal-proposals/email-pass-scan`),
  updateResponseMeta: (letterId, data) =>
    axios.put(`${API}/outreach/letters/${letterId}/response-meta`, data),
  undoLetterResponse: (letterId, reason) =>
    axios.post(`${API}/outreach/letters/${letterId}/undo-response`, { reason }),
  unmarkResponse: (letterId) =>
    axios.post(`${API}/outreach/letters/${letterId}/unmark-response`),
  deleteLetter: (letterId) =>
    axios.delete(`${API}/outreach/letters/${letterId}`),
  dismissDuplicateLetter: (letterId) =>
    axios.post(`${API}/outreach/letters/${letterId}/dismiss-duplicate`),
  sendLetterBack: (letterId, data) =>
    axios.post(`${API}/outreach/letters/${letterId}/send-back`, data),
  undoLetterSent: (letterId) =>
    axios.post(`${API}/outreach/letters/${letterId}/undo-sent`),
  takeLetterBack: (letterId) =>
    axios.post(`${API}/outreach/letters/${letterId}/take-back`),
  getLetterPdfUrl: (letterId) =>
    `${API}/outreach/letters/${letterId}/pdf`,
  exportAllLettersJson: () =>
    axios.get(`${API}/outreach/export-all-json`),
  exportAllLettersDocx: () =>
    axios.get(`${API}/outreach/export-all-docx`, { responseType: 'blob' }),
  exportAllLettersPdf: () =>
    axios.post(`${API}/outreach/export-all-pdf`, {}, { responseType: 'blob' }),

  // Landing pages
  createLandingFromLetter: (letterId) =>
    axios.post(`${API}/landing/from-letter/${letterId}`),
  getLandingByLetter: (letterId) =>
    axios.get(`${API}/landing/by-letter/${letterId}`),
  updateLanding: (lid, data) =>
    axios.put(`${API}/landing/${lid}`, data),
  rerenderLanding: (lid) =>
    axios.post(`${API}/landing/${lid}/rerender`),
  rerenderAllLandings: () =>
    axios.post(`${API}/landing/rerender-all`),
  getTeleprompterScript: (lid, force) =>
    axios.post(`${API}/landing/${lid}/teleprompter`, force ? { force: true } : {}),
  previewLandingAudio: (lid, data) =>
    axios.post(`${API}/landing/${lid}/preview-audio`, data || {}, { responseType: 'blob' }),
  generateLandingAudio: (lid, data) =>
    axios.post(`${API}/landing/${lid}/generate-audio`, data || {}),
  completeLandingVideo: (lid, uploadId) =>
    axios.post(`${API}/landing/${lid}/video/complete`, { upload_id: uploadId }),
  deleteLandingVideo: (lid) =>
    axios.delete(`${API}/landing/${lid}/video`),
  getLandingSettings: () =>
    axios.get(`${API}/landing/settings`),
  updateLandingSettings: (data) =>
    axios.put(`${API}/landing/settings`, data),
  uploadLandingPhoto: (formData) =>
    axios.post(`${API}/landing/settings/photo`, formData, { headers: { 'Content-Type': 'multipart/form-data' } }),
  getLandingVoices: () =>
    axios.get(`${API}/landing/voices`),
  getLandingOverview: () =>
    axios.get(`${API}/landing/overview`),
  getLandingAnalytics: () =>
    axios.get(`${API}/landing/analytics`),
  exportOutreachStats: () =>
    axios.get(`${API}/landing/analytics/export.xlsx`, { responseType: 'blob' }),
  getCleanOutreachStats: () =>
    axios.get(`${API}/landing/analytics/clean`),
  exportCleanOutreachStats: () =>
    axios.get(`${API}/landing/analytics/clean.zip`, { responseType: 'blob' }),
  getCleanOutreachMarkdown: () =>
    axios.get(`${API}/landing/analytics/clean.md`, { responseType: 'text' }),
  excludeLandingVisit: (visitId) =>
    axios.post(`${API}/landing/visits/${visitId}/exclude`),
  restoreLandingVisit: (visitId) =>
    axios.post(`${API}/landing/visits/${visitId}/restore`),
  getTestScans: () =>
    axios.get(`${API}/landing/test-scans`),
  getLandingCredits: () =>
    axios.get(`${API}/landing/credits`),
  resetLandingStats: (lid) =>
    axios.post(`${API}/landing/${lid}/reset-stats`),
  resetAllOutreachStats: () =>
    axios.post(`${API}/landing/analytics/reset`),
  deleteLanding: (lid) =>
    axios.delete(`${API}/landing/${lid}`),
  suggestLandingSentences: (lid) =>
    axios.post(`${API}/landing/${lid}/suggest-sentences`),
  autoAssignLanding: (lid) =>
    axios.post(`${API}/landing/${lid}/auto-assign`),
  getOutreachProgress: () =>
    axios.get(`${API}/landing/outreach-progress`),
  getMsConnections: () =>
    axios.get(`${API}/mstodo/connections`),
  getAbExperiments: () =>
    axios.get(`${API}/ab/experiments`),
  createAbExperiment: (data) =>
    axios.post(`${API}/ab/experiments`, data),
  updateAbExperiment: (id, data) =>
    axios.put(`${API}/ab/experiments/${id}`, data),
  deleteAbExperiment: (id) =>
    axios.delete(`${API}/ab/experiments/${id}`),
  backfillAbExperiment: (id) =>
    axios.post(`${API}/ab/experiments/${id}/backfill`),
  resetAbExperiment: (id) =>
    axios.post(`${API}/ab/experiments/${id}/reset`),
  getAbPages: () =>
    axios.get(`${API}/ab/pages`),
  setAbPageExcluded: (pageId, excluded) =>
    axios.put(`${API}/ab/pages/${pageId}/exclude`, { excluded }),
  getAbLive: (id) =>
    axios.get(`${API}/ab/experiments/${id}/live`),
  runHeuristics: () =>
    axios.post(`${API}/heuristics/run`),
  heuristicsStatus: () =>
    axios.get(`${API}/heuristics/status`),
  aiQuickScore: (projectId) =>
    axios.post(`${API}/projects/${projectId}/quick-score`),
  bulkQuickScore: (body) =>
    axios.post(`${API}/quick-score-bulk/start`, body),
  bulkQuickScoreStatus: () =>
    axios.get(`${API}/quick-score-bulk/status`),
  getThesisConfig: () =>
    axios.get(`${API}/thesis/config`),
  updateThesisConfig: (text) =>
    axios.put(`${API}/thesis/config`, { text }),
  thesisScanStart: (body) =>
    axios.post(`${API}/thesis/scan/start`, body || {}),
  thesisScanPause: () =>
    axios.post(`${API}/thesis/scan/pause`),
  thesisScanStatus: () =>
    axios.get(`${API}/thesis/scan/status`),
  thesisCreateBatch: (body) =>
    axios.post(`${API}/thesis/batches`, body),
  thesisLatestBatch: () =>
    axios.get(`${API}/thesis/batches/latest`),
  thesisRefinements: () =>
    axios.get(`${API}/thesis/refinements`),
  thesisAddRefinement: (text) =>
    axios.post(`${API}/thesis/refinements`, { text }),
  thesisToggleRefinement: (id, active) =>
    axios.put(`${API}/thesis/refinements/${id}`, { active }),
  thesisRerunRefinement: (id) =>
    axios.post(`${API}/thesis/refinements/${id}/rerun`),
  thesisDeleteRefinement: (id) =>
    axios.delete(`${API}/thesis/refinements/${id}`),
  thesisSimilarStart: (url, filters) =>
    axios.post(`${API}/thesis/similar/start`, { url, filters: filters || {} }),
  fundList: (params) =>
    axios.get(`${API}/thesis/funds`, { params: params || {} }),
  wbJobCreate: () => axios.post(`${API}/infra-funds/workbooks/jobs`),
  wbJobFiles: (jobId, files) => {
    const fd = new FormData();
    files.forEach(f => fd.append('files', f, f.name));
    return axios.post(`${API}/infra-funds/workbooks/jobs/${jobId}/files`, fd, { timeout: 300000 });
  },
  wbJobStart: (jobId) => axios.post(`${API}/infra-funds/workbooks/jobs/${jobId}/start`),
  wbJobGet: (jobId) => axios.get(`${API}/infra-funds/workbooks/jobs/${jobId}`),
  wbJobs: () => axios.get(`${API}/infra-funds/workbooks/jobs`),
  wbJobUndo: (jobId) => axios.delete(`${API}/infra-funds/workbooks/jobs/${jobId}/undo`),
  fundCreate: (name, website, filters, research = true) =>
    axios.post(`${API}/thesis/funds`, { name, website: website || '', filters: filters || {}, research }),
  fundCreateBulk: (items, research = true) =>
    axios.post(`${API}/thesis/funds/bulk`, { items, research }),
  iiExtract: (files, fundId) => {
    const fd = new FormData();
    files.forEach(f => fd.append('files', f, f.name));
    if (fundId) fd.append('fund_id', fundId);
    return axios.post(`${API}/infra-funds/ii/extract`, fd, { timeout: 600000 });
  },
  iiSave: (body) => axios.post(`${API}/infra-funds/ii/save`, body),
  iiPersonToContact: (fundId, person) => axios.post(`${API}/infra-funds/ii/${fundId}/contact`, person),
  iiJobCreate: () => axios.post(`${API}/infra-funds/ii/jobs`),
  iiJobFiles: (jobId, files, startIdx) => {
    const fd = new FormData();
    files.forEach(f => fd.append('files', f, f.name));
    fd.append('start_idx', String(startIdx));
    return axios.post(`${API}/infra-funds/ii/jobs/${jobId}/files`, fd, { timeout: 300000 });
  },
  iiJobStart: (jobId) => axios.post(`${API}/infra-funds/ii/jobs/${jobId}/start`),
  iiJobGet: (jobId) => axios.get(`${API}/infra-funds/ii/jobs/${jobId}`),
  iiJobs: () => axios.get(`${API}/infra-funds/ii/jobs`),
  fundGet: (id) =>
    axios.get(`${API}/thesis/funds/${id}`),
  fundScreen: (id, filters, themes) =>
    axios.post(`${API}/thesis/funds/${id}/screen`, { filters: filters || {}, themes: themes || [] }),
  fundThemes: (id) =>
    axios.get(`${API}/thesis/funds/${id}/themes`),
  exportFundThemes: (fundId) =>
    axios.get(`${API}/thesis/funds/export/themes.xlsx`, { params: fundId ? { fund_id: fundId } : {}, responseType: 'blob' }),
  fundResearch: (id, website, filters) =>
    axios.post(`${API}/thesis/funds/${id}/research`, { website: website || '', filters: filters || {} }),
  fundDelete: (id) =>
    axios.delete(`${API}/thesis/funds/${id}`),
  fundPin: (id, pinned) => axios.post(`${API}/thesis/funds/${id}/pin`, { pinned }),
  infraDeals: (fundId) => axios.get(`${API}/infra-funds/${fundId}/deals`),
  infraExtractDeals: (fundId, files) => {
    const fd = new FormData();
    files.forEach(f => fd.append('files', f));
    return axios.post(`${API}/infra-funds/${fundId}/deals/extract`, fd, { headers: { 'Content-Type': 'multipart/form-data' }, timeout: 300000 });
  },
  infraSaveDeals: (fundId, deals) => axios.post(`${API}/infra-funds/${fundId}/deals`, { deals }),
  infraUpdateDeal: (dealId, body) => axios.put(`${API}/infra-funds/deals/${dealId}`, body),
  infraDeleteDeal: (dealId) => axios.delete(`${API}/infra-funds/deals/${dealId}`),
  infraResearchDeals: (fundId, body) => axios.post(`${API}/infra-funds/${fundId}/deals/research`, body || {}),
  infraResearchDeal: (dealId) => axios.post(`${API}/infra-funds/deals/${dealId}/research`),
  infraFundAngles: (fundId) => axios.get(`${API}/infra-funds/${fundId}/angles`),
  infraAllAngles: () => axios.get(`${API}/infra-funds/angles`),
  infraScreenAngles: (labels, filters) => axios.post(`${API}/infra-funds/angles/screen`, { labels, filters: filters || {} }),
  infraScreenDeal: (dealId, filters) => axios.post(`${API}/infra-funds/deals/${dealId}/screen`, { filters: filters || {} }),
  infraDealScreen: (dealId) => axios.get(`${API}/infra-funds/deals/${dealId}/screen`),
  infraRun: (runId) => axios.get(`${API}/infra-funds/runs/${runId}`),
  infraRunReset: (runId) => axios.post(`${API}/infra-funds/runs/${runId}/reset`),
  thesisSimilarLatest: () =>
    axios.get(`${API}/thesis/similar/latest`),
  thesisSimilarDismiss: () =>
    axios.post(`${API}/thesis/similar/dismiss`),
  getDealOutreachTracking: (projectId) =>
    axios.get(`${API}/landing/deal/${projectId}/tracking`),
  getHotDeals: () =>
    axios.get(`${API}/landing/hot-deals`),
  switchToAbTest: () =>
    axios.post(`${API}/ab/experiments/switch-to-ab`),
  getReferenceCalls: (projectId) =>
    axios.get(`${API}/projects/${projectId}/reference-calls`),
  addReferenceCall: (projectId, data) =>
    axios.post(`${API}/projects/${projectId}/reference-calls`, data),
  deleteReferenceCall: (projectId, refId) =>
    axios.delete(`${API}/projects/${projectId}/reference-calls/${refId}`),
  addAcKeyUpdate: (projectId, text) =>
    axios.post(`${API}/projects/${projectId}/ac-key-updates`, { text }),
  deleteAcKeyUpdate: (projectId, entryId) =>
    axios.delete(`${API}/projects/${projectId}/ac-key-updates/${entryId}`),
  getWeeklyEngagement: () =>
    axios.get(`${API}/landing/engagement/weekly`),
  getMeetingAttendance: () =>
    axios.get(`${API}/meetings/attendance`),
  setMeetingAttendance: (presentIds, guests) =>
    axios.put(`${API}/meetings/attendance`, { present_ids: presentIds, guests: guests || '' }),
  approvalWorkplace: () =>
    axios.get(`${API}/outreach/approval-workplace`),
  setInvestorMode: (on) =>
    axios.post(`${API}/auth/investor-mode`, { on }),
  releaseBreakupLetters: (letterIds) =>
    axios.post(`${API}/outreach/breakup-review/release`, { letter_ids: letterIds || [] }),
  outreachSummary: () =>
    axios.get(`${API}/outreach/summary`),
  exportApprovalPackage: (letterIds, origin) =>
    axios.post(`${API}/outreach/export-package`, { letter_ids: letterIds, origin }, { responseType: 'blob' }),
  // iAuto handwriting machine print queue
  printSettings: () =>
    axios.get(`${API}/print/settings`),
  updatePrintSettings: (data) =>
    axios.put(`${API}/print/settings`, data),
  regeneratePrintAgentKey: () =>
    axios.post(`${API}/print/settings/regenerate-key`),
  uploadPrintFont: (formData) =>
    axios.post(`${API}/print/font`, formData, { headers: { 'Content-Type': 'multipart/form-data' } }),
  deletePrintFont: () =>
    axios.delete(`${API}/print/font`),
  createPrintJob: (letterId, force, docType) =>
    axios.post(`${API}/print/jobs`, { letter_id: letterId, force: !!force, doc_type: docType || 'letter' }),
  setPrintJobDate: (jobId, dateOverride) =>
    axios.put(`${API}/print/jobs/${jobId}/date`, { date_override: dateOverride || null }),
  setPrintBatchDate: (batchId, dateOverride) =>
    axios.put(`${API}/print/batch/${batchId}/date`, { date_override: dateOverride || null }),
  setPrintQueueDate: (dateOverride, kind) =>
    axios.put(`${API}/print/queue/date`, { date_override: dateOverride || null, kind: kind || 'all' }),
  createPrintBatch: (docType, letterIds, deviceId, envelopeKind, breakupDeviceId) =>
    axios.post(`${API}/print/batch`, { doc_type: docType, ...(letterIds?.length ? { letter_ids: letterIds } : {}), ...(deviceId ? { device_id: deviceId } : {}), ...(envelopeKind ? { envelope_kind: envelopeKind } : {}), ...(breakupDeviceId ? { breakup_device_id: breakupDeviceId } : {}) }),
  splitPrintBatchKind: (batchId, deviceId) =>
    axios.post(`${API}/print/batch/${batchId}/split-kind`, deviceId ? { device_id: deviceId } : {}),
  getPrintQueueDateBlocks: (kind = 'standard', blockSize = 50) =>
    axios.get(`${API}/print/queue/date-blocks`, { params: { kind, block_size: blockSize } }),
  splitPrintBatchBlocks: (batchId, blockSize = 50) =>
    axios.post(`${API}/print/batch/${batchId}/split-blocks`, { block_size: blockSize }),
  setPrintQueueDateBlocks: (kind, blockSize, dates) =>
    axios.put(`${API}/print/queue/date-blocks`, { kind, block_size: blockSize, dates }),
  getEnvelopeCandidates: () =>
    axios.get(`${API}/print/envelope-candidates`),
  startPrintBatch: (batchId) =>
    axios.post(`${API}/print/batch/${batchId}/start`),
  appendToPrintBatch: (batchId) =>
    axios.post(`${API}/print/batch/${batchId}/append`, { doc_type: 'letter' }),
  deletePrintBatch: (batchId, force = false) =>
    axios.delete(`${API}/print/batch/${batchId}`, { params: force ? { force: 1 } : {} }),
  setPreviewCheck: (letterId, doc, checked) =>
    axios.post(`${API}/print/preview-check`, { letter_id: letterId, doc, checked }),
  printMailingStatus: () =>
    axios.get(`${API}/print/mailing-status`),
  markAllPrintSent: (letterIds) =>
    axios.post(`${API}/print/mark-all-sent`, { ...(letterIds?.length ? { letter_ids: letterIds } : {}) }),
  getSentCandidates: () =>
    axios.get(`${API}/print/sent-candidates`),
  createTestPrint: (data) =>
    axios.post(`${API}/print/test-letter`, data || {}),
  skipPrintWait: () =>
    axios.post(`${API}/print/skip-wait`),
  setPairCheck: (letterId, checked) =>
    axios.post(`${API}/print/pair-check`, { letter_id: letterId, checked }),
  printPreviewLetters: () =>
    axios.get(`${API}/print/preview-letters`),
  getPrintLetterOverrides: (letterId) =>
    axios.get(`${API}/print/letters/${letterId}/overrides`),
  savePrintLetterOverrides: (letterId, data) =>
    axios.put(`${API}/print/letters/${letterId}/overrides`, data),
  clearPrintQueue: (includeSent = false) =>
    axios.delete(`${API}/print/jobs-queued`, { params: includeSent ? { include_sent: 1 } : {} }),
  downloadFlyerPdf: () =>
    axios.get(`${API}/print/flyer-pdf`, { params: { origin: window.location.origin }, responseType: 'blob' }),
  downloadBlankFlyerPdf: () =>
    axios.get(`${API}/print/blank-flyer-pdf`, { responseType: 'blob' }),
  downloadQrOverlayPdf: () =>
    axios.get(`${API}/print/qr-overlay-pdf`, { params: { origin: window.location.origin }, responseType: 'blob' }),
  downloadQrOverlayTestPdf: () =>
    axios.get(`${API}/print/qr-overlay-test-pdf`, { responseType: 'blob' }),
  getFlyerStock: () => axios.get(`${API}/print/flyer-stock`),
  writeFlyerStock: (packages, deviceId) => axios.post(`${API}/print/flyer-stock/write`, { packages, device_id: deviceId || '' }),
  consumeFlyerStock: (letterIds) => axios.post(`${API}/print/flyer-stock/consume`, { letter_ids: letterIds || [] }),
  adjustFlyerStock: (delta, reason) => axios.post(`${API}/print/flyer-stock/adjust`, { delta, reason }),
  getFlyerQrPackages: () => axios.get(`${API}/print/flyer-stock/packages`),
  createFlyerQrPackage: (letterIds) => axios.post(`${API}/print/flyer-stock/packages`, { letter_ids: letterIds || [] }),
  downloadFlyerQrPackagePdf: (pid) =>
    axios.get(`${API}/print/flyer-stock/packages/${pid}/pdf`, { params: { origin: window.location.origin }, responseType: 'blob' }),
  consumeFlyerQrPackage: (pid) => axios.post(`${API}/print/flyer-stock/packages/${pid}/consume`),
  dissolveFlyerQrPackage: (pid) => axios.delete(`${API}/print/flyer-stock/packages/${pid}`),
  downloadQrOverlaySelected: (letterIds, kind, dx, dy) =>
    axios.post(`${API}/print/qr-overlay-pdf/selected`,
      { letter_ids: letterIds, kind, origin: window.location.origin, dx_mm: dx, dy_mm: dy }, { responseType: 'blob' }),
  downloadBreakupQrOverlayPdf: () =>
    axios.get(`${API}/print/breakup-qr-overlay-pdf`, { params: { origin: window.location.origin }, responseType: 'blob' }),
  downloadBreakupQrTestPdf: () =>
    axios.get(`${API}/print/breakup-qr-test-pdf`, { responseType: 'blob' }),
  sendFlyerToPrintclub: (quantity) =>
    axios.post(`${API}/print/flyer-pdf/send`, { quantity }),
  printclubStatus: () =>
    axios.get(`${API}/print/printclub-status`),
  getPrintedFlyers: () =>
    axios.get(`${API}/print/flyers-printed`),
  reprintFlyers: (letterIds) =>
    axios.post(`${API}/print/flyers-reprint`, { letter_ids: letterIds }),
  listPrintJobs: () =>
    axios.get(`${API}/print/jobs`),
  deletePrintJob: (id) =>
    axios.delete(`${API}/print/jobs/${id}`),
  retryPrintJob: (id) =>
    axios.post(`${API}/print/jobs/${id}/retry`),
  reprintPrintJobIdentical: (id) =>
    axios.post(`${API}/print/jobs/${id}/reprint-identical`),
  retryAllPrintErrors: () =>
    axios.post(`${API}/print/jobs/retry-errors`),
  getPrintJobSvg: (id) =>
    axios.get(`${API}/print/jobs/${id}/svg`),
  getPrintPreview: (letterId, page, doc) =>
    axios.get(`${API}/print/preview/${letterId}`, {
      params: { page: page || 1, doc: doc || 'letter', origin: process.env.REACT_APP_BACKEND_URL } }),
  printPreviewSample: (data) =>
    axios.post(`${API}/print/preview-sample`, data || {}),
  downloadPrintAgentScript: (deviceId, platform) =>
    axios.get(`${API}/print/agent-script`, { params: { origin: process.env.REACT_APP_BACKEND_URL, ...(deviceId ? { device_id: deviceId } : {}), ...(platform ? { platform } : {}) }, responseType: 'blob' }),
  createPrintDevice: (name, hostId = '') =>
    axios.post(`${API}/print/devices`, hostId ? { name, host_id: hostId } : { name }),
  updatePrintDevice: (id, data) =>
    axios.put(`${API}/print/devices/${id}`, data),
  activatePrintDevice: (id) =>
    axios.post(`${API}/print/devices/${id}/activate`),
  regeneratePrintDeviceKey: (id) =>
    axios.post(`${API}/print/devices/${id}/regenerate-key`),
  deletePrintDevice: (id) =>
    axios.delete(`${API}/print/devices/${id}`),
  getPrintDeviceLog: (id) =>
    axios.get(`${API}/print/devices/${id}/log`),
  requestPrintDeviceDiagnose: (id) =>
    axios.post(`${API}/print/devices/${id}/diagnose`),
  reassignPrintJobDevice: (jobId, deviceId) =>
    axios.put(`${API}/print/jobs/${jobId}/device`, { device_id: deviceId }),
  reassignPrintBatchDevice: (batchId, deviceId) =>
    axios.put(`${API}/print/batch/${batchId}/device`, { device_id: deviceId }),
  splitQueueDevices: () =>
    axios.post(`${API}/print/queue/split-devices`),
  // Webex Calling
  webexStatus: () =>
    axios.get(`${API}/webex/status`),
  webexConnect: () =>
    axios.get(`${API}/webex/connect`),
  webexDisconnect: () =>
    axios.post(`${API}/webex/disconnect`),
  webexServiceApp: (refreshToken) =>
    axios.post(`${API}/webex/serviceapp`, { refresh_token: refreshToken }),
  webexSync: () =>
    axios.post(`${API}/webex/sync`),
  webexBackfill: (hours) =>
    axios.post(`${API}/webex/backfill`, null, { params: { hours: hours || 48 } }),
  webexLines: () =>
    axios.get(`${API}/webex/lines`),
  webexUpdateLines: (lines) =>
    axios.put(`${API}/webex/lines`, { lines }),
  webexAnalytics: (days) =>
    axios.get(`${API}/webex/analytics`, { params: { days } }),
  webexCalls: (params) =>
    axios.get(`${API}/webex/calls`, { params }),
  webexAssignCall: (callId, projectId) =>
    axios.post(`${API}/webex/calls/${callId}/assign`, { project_id: projectId }),
  webexIgnoreCall: (callId) =>
    axios.post(`${API}/webex/calls/${callId}/ignore`),
  webexMarkCallPrivate: (callId) =>
    axios.post(`${API}/webex/calls/${callId}/private`),
  webexAssignCallContact: (callId, contactId) =>
    axios.post(`${API}/webex/calls/${callId}/assign-contact`, { contact_id: contactId }),
  webexPlaudItems: () =>
    axios.get(`${API}/webex/plaud-items`),
  webexLinkPlaud: (callId, plaudId) =>
    axios.post(`${API}/webex/calls/${callId}/plaud-note`, { plaud_id: plaudId }),
  brokerEngagements: () =>
    axios.get(`${API}/webex/broker-engagements`),
  brokerPlaudSummarize: (body) =>
    axios.post(`${API}/webex/broker-engagements/plaud-summarize`, body),
  addBrokerMeeting: (body) =>
    axios.post(`${API}/webex/broker-meetings`, body),
  deleteBrokerMeeting: (mid) =>
    axios.delete(`${API}/webex/broker-meetings/${mid}`),
  syncBrokerCalendar: () =>
    axios.post(`${API}/webex/broker-calendar/sync`),
  brokerConfirmDealLink: (body) =>
    axios.post(`${API}/webex/broker-engagements/confirm-deal-link`, body),
  brokerDismissDealLink: (body) =>
    axios.post(`${API}/webex/broker-engagements/dismiss-deal-link`, body),
  brokerEditPlaudNote: (body) =>
    axios.post(`${API}/webex/broker-engagements/plaud-note-edit`, body),

  // On-Site-Planer
  onsiteList: (pid) => axios.get(`${API}/projects/${pid}/onsites`),
  onsiteCreate: (pid, body) => axios.post(`${API}/projects/${pid}/onsites`, body),
  onsiteGet: (id) => axios.get(`${API}/onsites/${id}`),
  onsitePatch: (id, set, section) => axios.patch(`${API}/onsites/${id}`, { set, section }),
  onsiteDelete: (id) => axios.delete(`${API}/onsites/${id}`),
  onsiteCheck: (id, list, itemId, done) => axios.post(`${API}/onsites/${id}/check`, { list, item_id: itemId, done }),
  onsiteStatus: (id, status) => axios.post(`${API}/onsites/${id}/status`, { status }),
  onsitePrefill: (id) => axios.post(`${API}/onsites/${id}/prefill`),
  onsiteExternalDraft: (id) => axios.post(`${API}/onsites/${id}/external/draft`),
  onsiteExternalGenerate: (id) => axios.post(`${API}/onsites/${id}/external/generate`),
  onsiteExternalSend: (id, body) => axios.post(`${API}/onsites/${id}/external/send`, body),
  onsiteTasks: (id, list) => axios.post(`${API}/onsites/${id}/tasks`, { list }),
  // On-Site Leitfaden-Runner
  guidesList: (planId) => axios.get(`${API}/onsites/${planId}/guides`),
  guidesLive: (planId) => axios.get(`${API}/onsites/${planId}/guides/live`),
  guideCreate: (planId, formData) => axios.post(`${API}/onsites/${planId}/guides`, formData, { headers: { 'Content-Type': 'multipart/form-data' } }),
  guideGet: (gid) => axios.get(`${API}/guides/${gid}`),
  guidePatch: (gid, body) => axios.patch(`${API}/guides/${gid}`, body),
  guideDelete: (gid) => axios.delete(`${API}/guides/${gid}`),
  guideMoveQuestion: (gid, qid, targetGuideId, mode) => axios.post(`${API}/guides/${gid}/questions/${qid}/move`, { target_guide_id: targetGuideId, mode }),
  guideRemarkablePdf: (gid) => axios.get(`${API}/guides/${gid}/remarkable.pdf`, { responseType: 'blob' }),
  guideReparse: (gid) => axios.post(`${API}/guides/${gid}/reparse`),
  guideProgress: (gid, body) => axios.post(`${API}/guides/${gid}/progress`, body),
  guideCursor: (gid, questionId) => axios.post(`${API}/guides/${gid}/cursor`, { question_id: questionId }),
  guidesToDebrief: (planId) => axios.post(`${API}/onsites/${planId}/guides/debrief`),
  guidesExport: (planId) => axios.post(`${API}/onsites/${planId}/guides/export`),
};
